import type { PartialRecord } from '@/core/helperTypes'

export const CustomerPlan = {
  FREE_TIER: 'Free Tier',
  STARTER_YEARLY: 'Starter Yearly',
  STARTER_MONTHLY: 'Starter Monthly',
} as const

export type CustomerPlanType = (typeof CustomerPlan)[keyof typeof CustomerPlan]

export enum StripeSubscriptionStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unpaid = 'unpaid',
}

export enum ProductType {
  AnnotationCredits = 'annotation_credits',
  Storage = 'storage',
  Training = 'training',
}

export type CustomerPayload = {
  id: number
  stripe_subscription_period_end: number | null
  stripe_subscription_period_start: number | null
  stripe_subscription_status: StripeSubscriptionStatus | null
  team_id: number
}

export enum RenewalInterval {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Biyearly = 'biyearly',
  Yearly = 'yearly',
}

export type CustomerSubscriptionPayload = {
  annotation_credits_bonus: number
  annotation_credits_standard: number
  annotation_credits_standard_max_in_period: number
  annotation_credits_standard_max_in_period_at: number
  annotation_credits_used: number
  storage_extra: number
  storage_standard: number
  storage_standard_max_in_period: number
  storage_standard_max_in_period_at: number
  storage_used: number
  locked_out: boolean
  locked_out_reasons: string[] | null
  external_storage_buckets: number // limit allowed buckets for the team
  external_storage_buckets_used: number // number of used ext storage buckets
  renewal_interval: RenewalInterval // subscription renewal interval
}

export type BillingInfoPayload = {
  clients: BillingInfoPayload[]
  customer: CustomerPayload
  customer_subscription: CustomerSubscriptionPayload
}

export type UsageInfo = {
  id: string
  name: string
  color: string
  isChild?: boolean
  credit: {
    human: number
    automation: number
    model: number
    client: number
    available: number
    used: number
    limit?: number
  }
  storage: {
    used: number
    available: number
    managedFiles: number
    filesInClient?: number
    limit?: number
  }
}

export type ClientTeamLimitMap = PartialRecord<
  string,
  | {
      id: string
      color: string
      partnerId: number
      name: string
      creditLimit: number | undefined
      storageLimit: number | undefined
    }
  | undefined
>
